import { CATEGORY_ICONS, FileCategory, FORMAT_TO_CATEGORY, MIME_PREFIXES } from './file-uploader.config';

function resolveCategory(token: string): FileCategory | null {
  const lower = token.toLowerCase().trim();

  const exact = FORMAT_TO_CATEGORY[lower];
  if (exact) return exact;

  for (const { prefix, category } of MIME_PREFIXES) {
    if (lower.startsWith(prefix)) return category;
  }

  return null;
}

export function getFileIconFromFormats(formats: string | null): string | null {
  if (!formats) return null;

  const tokens = formats
    .split(',')
    .map((t) => t.trim())
    .filter(Boolean);
  if (tokens.length === 0) return null;

  const categories = new Set<FileCategory>();

  for (const token of tokens) {
    const category = resolveCategory(token);
    if (!category) return null;
    categories.add(category);
  }

  if (categories.size !== 1) return null;

  return CATEGORY_ICONS[[...categories][0]];
}
